<template>
<v-container>
    <v-row class="">
        <v-col cols="12" class="mt-1  font-weight-black">

            Facebook Option

        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3">

            <v-card @click="goVideope()" class="rounded-xl mx-auto mt-0 " style="">
                <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">

                    <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
                    <!-- <v-spacer></v-spacer>
            PreView -->
                    <v-spacer></v-spacer>
                    <v-icon color="white">
                        mdi-eye
                    </v-icon>
                </v-card-title>
                <v-card-text class='pb-10'>
                    <v-row>
                        <v-col cols='12'>
                            <v-subheader class="red--text text--lighten-1 pl-0 subheader">Premium</v-subheader>
                            <h3 style="">
                                Video PE
                            </h3>
                            <br />
                            <!-- <v-btn block>
                  Login
                </v-btn> -->
                        </v-col>

                    </v-row>
                </v-card-text>

            </v-card>

        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3">
            <v-card class="rounded-xl mx-auto mt-0 " @click="goClone">
                <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">

                    <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
                    <v-spacer></v-spacer>
                    <v-icon color="white">
                        mdi-eye
                    </v-icon>
                </v-card-title>
                <v-card-text class='pb-10'>
                    <v-row>
                        <v-col cols='12'>
                            <v-subheader class="red--text text--lighten-1 pl-0 subheader">Premium</v-subheader>
                            <h3>
                                Clone PE
                            </h3>
                            <br />
                            <!-- <v-btn block>
                  Login
                </v-btn> -->
                        </v-col>

                    </v-row>
                </v-card-text>

            </v-card>

        </v-col>
        <v-col cols="12" sm="12" md="3" lg="3">
            <v-card class="rounded-xl mx-auto mt-0 "  @click="goDelete">
                <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">

                    <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
                    <v-spacer></v-spacer>
                    <v-icon color="white">
                        mdi-eye
                    </v-icon>

                </v-card-title>
                <v-card-text class='pb-10'>
                    <v-row>
                        <v-col cols='12'>
                            <!-- <v-subheader class="grey--text text--lighten-1 pl-0 subheader">Premium ( Comming Soon )</v-subheader> -->
                            <v-subheader class="red--text text--lighten-1 pl-0 subheader">Premium</v-subheader>
                            <h3>
                              Auto Delete Post
                            </h3>
                            <br />
                            <!-- <v-btn block>
                  Login
                </v-btn> -->
                        </v-col>

                    </v-row>
                </v-card-text>

            </v-card>

        </v-col>

        <v-col cols="12" sm="12" md="3" lg="3">
            <v-card class="rounded-xl mx-auto mt-0 " @click="gochedule">
                <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">

                    <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
                    <v-spacer></v-spacer>
                    <v-icon color="white">
                        mdi-eye
                    </v-icon>
                </v-card-title>
                <v-card-text class='pb-10'>
                    <v-row>
                        <v-col cols='12'>
                            <v-subheader class="red--text text--lighten-1 pl-0 subheader">Premium</v-subheader>
                            <h3>
                               View Schedule
                            </h3>
                            <br />
                            <!-- <v-btn block>
                  Login
                </v-btn> -->
                        </v-col>

                    </v-row>
                </v-card-text>

            </v-card>

        </v-col>    

        <v-col cols="12" sm="12" md="3" lg="3">
            <v-card class="rounded-xl mx-auto mt-0 ">
                <v-card-title class="red darken-0 white--text font-weight-black " style="font-size: 14px;">

                    <!-- <v-img aspect-ratio="3.075" max-height="40" :src="require('@/assets/fb.png/')" position="left" contain /> -->
                    <v-spacer></v-spacer>
                    <v-icon color="white">
                        mdi-eye
                    </v-icon>
                </v-card-title>
                <v-card-text class='pb-10'>
                    <v-row>
                        <v-col cols='12'>
                            <v-subheader class="grey--text text--lighten-1 pl-0 subheader">Premium (Comming Soon)</v-subheader>
                            <h3>
                                Share to Group
                            </h3>
                            <br />
                            <!-- <v-btn block>
                  Login
                </v-btn> -->
                        </v-col>

                    </v-row>
                </v-card-text>

            </v-card>

        </v-col>

    </v-row>
    <v-row class="">
        <v-col cols="12" class="mt-1  font-weight-black">

            TikTok Comming Soon

        </v-col>

    </v-row>
    <v-dialog v-model="dialog" persistent max-width="290">

        <v-card>
            <v-card-title class="text-h5">

                Facebook Login
            </v-card-title>

            <v-card-text>
                Please go to login facebook first !
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn color="green darken-1" text @click="loginFacebook()">
                    Login Facebook
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialog_no_ads" persistent max-width="290">

        <v-card>
            <v-card-title class="text-h6">

                Facebook Ads
            </v-card-title>

            <v-card-text>
                Please go to create your ads account first
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="logout()">
                    Logout
                </v-btn>
                <v-btn color="green darken-1" text @click="installextension()">
                    Reload
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <v-dialog v-model="dialogExtention" persistent max-width="290">

        <v-card>
            <v-card-title class="text-h5">

                Install Extension
            </v-card-title>

            <v-card-text>
                Please go to Install Chrome Extensions Cam-Tool
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="logout()">
                    Logout
                </v-btn>
                <v-btn color="green darken-1" text @click="installextension()">
                    Reload
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_find_url" persistent max-width="290">

        <v-card>
            <v-card-title class="text-h6">

                Find URL
            </v-card-title>

            <v-card-text>
                Cannot Find URL Ads
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click="logout()">
                    Logout
                </v-btn>
                <v-btn color="green darken-1" text @click="installextension()">
                    Reload
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <v-overlay :value="overlay">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
</v-container>
</template>

<script>
export default {
    name: 'HelloWorld',

    data: () => ({
        dialog_find_url: false,
        dialog_no_ads: false,
        overlay: false,
        URL_IMAGE: './src/assets/fb.png',
        isLogin: '',
        myResult: [],
        fbUserName: '',
        fbUserID: '',
        dialog: false,
        dialogExtention: false
    }),

    methods: {
        extractAccessToken(html) {
            if (typeof html !== 'string') return ''

            // Ads Manager currently exposes the user token through this variable.
            // Keep a generic EAA fallback for older versions of the response.
            const match = html.match(/window\.__accessToken\s*=\s*["']([^"']+)["']/) ||
                html.match(/\b(EAA[A-Za-z0-9_-]+)\b/)

            return match ? match[1] : ''
        },
        extractRedirectUrl(html) {
            if (typeof html !== 'string') return ''

            const match = html.match(/window\.location\.replace\(\s*["']([^"']+)["']\s*\)/)
            return match ? match[1].replace(/\\\//g, '/') : ''
        },
        saveAccessToken(html) {
            const token = this.extractAccessToken(html)
            if (!token) return false

            localStorage.setItem('accessToken', token)
            return true
        },
        loadAccessTokenFromFacebook() {
            const adsManagerUrl = 'https://www.facebook.com/adsmanager/manage/campaigns'

            return $.ajax({ url: adsManagerUrl, type: 'get' })
                .then((html) => {
                    if (this.saveAccessToken(html)) return true

                    const redirectUrl = this.extractRedirectUrl(html)
                    if (!redirectUrl) {
                        this.dialog_find_url = true
                        return false
                    }

                    const nextUrl = new URL(redirectUrl, adsManagerUrl)
                    nextUrl.searchParams.set('nav_source', 'no_referrer')

                    return $.ajax({ url: nextUrl.toString(), type: 'get' })
                        .then((redirectedHtml) => {
                            if (this.saveAccessToken(redirectedHtml)) return true

                            this.dialog_no_ads = true
                            return false
                        })
                })
                .catch(() => {
                    this.dialogExtention = true
                    return false
                })
        },
        logout() {
            localStorage.removeItem('hasLogin')
            localStorage.removeItem('info')
            this.$router.push({
                name: "login"
            });
            this.$store.commit("setAuthentication", false);
        },
        gochedule(){

            this.$router.push('viewschedule')
        },
        goDelete(){
            this.$router.push('delete')
        },
        goClone() {

            this.$router.push('clone')
        },
        goVideope() {

            this.$router.push('fbvideope')
        },
        goFbshare() {
            this.$router.push('fb-share')
        },
        goToCreatePage() {
            this.$router.push('fb-create-page')
        },
        goToClone() {
            this.$router.push('fb-clone')
        },
        loginFacebook() {
            window.location.href = "https://m.facebook.com"
        },
        installextension() {
            window.location.reload()
            // this.dialogExtention = false
        }
    },
    mounted() {
        // if (this.isLogin == true) {

        //   this.$swal('Facebook Login', 'Please login  facebook', 'error');

        // }
        // this.isLogin = JSON.parse(localStorage.getItem("isLogin"));
        // axios.get('https://m.facebook.com/composer/ocelot/async_loader/?publisher=feed').then((data) => {

        //   var trim_string = data.data.split('CurrentUserInitialData');
        //   var data_text = trim_string[1].split('\",[],')[1]
        //   data_text = data_text.split('SHORT_NAME')
        //   var json_text = data_text[0] + '}'
        //   this.myResult = json_text.split(',').map(s => s.trim());
        //   var userName = this.myResult[2].split('NAME')[1]
        //   var id = this.myResult[1].split('USER_ID')[1]
        //   this.fbUserID = id.replace(/[^a-zA-Z0-9]/g, "")
        //   this.fbUserName = userName.replace(/[^a-zA-Z ]/g, "")
        //   this.dialogExtention = false

        //   if (this.fbUserName != '') {

        //     this.dialog = false

        //     $.ajax({
        //       url: "https://www.facebook.com/adsmanager/manage/campaigns",
        //       type: "get",
        //       success: function (t) {
        //         if (-1 != t.search("EAA")) {
        //           var o = t.match(/EAAB.*?\"/),
        //             n = o[0] ? o[0].replace(/\W/g, "") : "";
        //           console.log(e(n))
        //         } else {
        //           var url_re = t.split("window.location.replace")
        //           var last_url = url_re[1].split('script')[0].replace('("', "").replace('");</', "").split('campaigns?')

        //           $.ajax({
        //             url: "https://www.facebook.com/adsmanager/manage/campaigns?".concat(last_url[1], "&nav_source=no_referrer"),
        //             type: "get",
        //             success: function (t) {
        //               if (-1 == t.search("EAA")) return e("");
        //               var o = t.match(/EAAB.*?\"/),
        //                 n = o[0] ? o[0].replace(/\W/g, "") : "";
        //               var s = t.split('DTSGInitialData')[1].split('\",[],')[1].replace(',258],["ISB', "")
        //               var j_text = JSON.parse(s)
        //               localStorage.setItem("dsg", j_text.token)
        //               localStorage.setItem("accessToken", n)

        //             }
        //           })

        //         }

        //       }
        //     })

        //   } else {

        //     this.dialog = false

        //   }

        // }).catch((data) => {

        //   this.dialogExtention = false

        // })
        this.overlay = true;
        const token = localStorage.getItem('accessToken');
        $.ajax({
            url: "https://graph.facebook.com/me",
            data: {
                access_token: token || ''
            }
        }).then((data) => {
            if (Object.prototype.hasOwnProperty.call(data, 'error')) {
                return this.loadAccessTokenFromFacebook()
            }
            return true
        }).fail(() => this.loadAccessTokenFromFacebook())
            .always(() => {
                this.overlay = false
            })

    },
    computed: {
        height() {
            switch (this.$vuetify.breakpoint.name) {
                case 'xs':
                    return 220
                case 'sm':
                    return 400
                case 'md':
                    return 500
                case 'lg':
                    return 600
                case 'xl':
                    return 800
            }
        },
    },
    created() {

    }

}
</script>
